// The site header is rendered on the server with the signed-in account (the
// account pill), so cached pages (public/sw.js, F173) carry it. They stay in
// this browser only, but a page shown offline after signing out, or as someone
// else, would show the old account: sign-in and sign-out drop them.
export function clearPageCaches(): void {
  if (typeof caches === "undefined") return;
  void caches
    .keys()
    .then((keys) => Promise.all(keys.filter((k) => k.startsWith("pages-")).map((k) => caches.delete(k))))
    .catch(() => {});
}
